const email = "dean.mcneil.developer@gmail.com";
export default email;